import { config } from '@/config'

// For testing purposes, we want to run the interval every 2 seconds.
// Otherwise, we would run the checker every minute.
export const TIMEOUT_CHECKER_INTERVAL = config.ibc.timeoutTesting ? 2 * 1000 : 60 * 1000
